
<template>
    <div>
      <vxe-modal height="80vh" width="60vw" title="推理图谱" className="dialog-taskcenter"  v-model="dialogTimeLineVisible" show-zoom>
          <v-timeline dense>
              <v-timeline-item v-for="item in tableData" small
              fill-dot>
              <v-card >
                  <v-card-title>{{ item.desc }}</v-card-title>
                  <v-card-text v-if="item.time!=''">{{'完成时间：'+ item.time}}</v-card-text>
                  <v-card-text v-else>{{ '未完成' }}</v-card-text>
              </v-card>
              </v-timeline-item>
          </v-timeline>
      </vxe-modal>
    </div>
  </template>
  
  <script>
  
  export default {
      name:'dialogTimeLine',
      data(){
          return{
              dialogTimeLineVisible:false,
              tableData:[]
          }
      },
      methods:{
          getData(tableData){
              this.tableData=tableData;
              this.dialogTimeLineVisible=true;
             
  
          }
      },
      mounted(){}
  }
  </script>
  
  <style scoped>
  
  </style>
  
  